export const GET_KITS = `/kits`
